import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StudentService } from '../../../../../shared-components/student/student.service';
import { YearService } from '../../../../../shared-components/year/year.service';
import { StudentSummaryService } from '../../../student-summary.service';
import { CardAttendance } from './card-attendance';
import { MatDialog } from '@angular/material/dialog';
import { AttendanceCardModalComponent } from './attendance-card-modal/attendance-card-modal.component';
import { Card } from '../../../card-container/card/card';
import { LoginService } from '../../../../../shared-modules/login/login.service';
import { interval } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe({
    includeArrays: true
})

@Component({
    selector: 'app-attendance-card',
    templateUrl: './attendance-card.component.html',
    styleUrls: ['./attendance-card.component.css']
})

export class AttendanceCardComponent implements OnInit, OnDestroy {
    @Input() data: any;
    card: Card;
    studentAttendance: CardAttendance[] = [];
    attendanceTotals: CardAttendance;
    displayedColumns: string[] = ['Class', 'Meets', 'Marked'];
    todaysTardyCount = 0;
    todaysAbsentCount = 0;
    yearToDateTardyCount = 0;
    yearToDateAbsentCount = 0;
    DaysPresent = 0;
    TotalDays = 0;
    HoursPresent = 0;
    TotalHours = 0;
    v10: boolean;
    dailyAttendance: boolean;
    dailyAttendanceStatus: string;

    constructor(
        private loginService: LoginService,
        private dialog: MatDialog,
        private router: Router,
        private studentService: StudentService,
        private studentSummaryService: StudentSummaryService,
        private yearService: YearService
    ) {
    }

    ngOnInit() {
        this.v10 = this.loginService.LoginSettings.V10;
        this.dailyAttendance = this.loginService.LoginSettings.ViewDailyAttendance;
        this.card = this.data;
        if (this.card.display == 'Detail' && this.loginService.LoginSettings.ViewDailyAttendance)
            this.card.display = 'Summary';
        if (this.card.display != 'Off') {
            const schoolIdStream = interval(100).subscribe(x => {
                if (this.studentService.studentEnrollment !== undefined) {
                    this.getAttendance();
                    schoolIdStream.unsubscribe();
                }
            });
        }
    }

    ngOnDestroy(): void {
    }

    getAttendance() {
        // Clear all the fields
        this.yearToDateTardyCount = 0;
        this.yearToDateAbsentCount = 0;
        this.todaysAbsentCount = 0;
        this.todaysTardyCount = 0;
        // Reset the student attendance objects
        this.studentAttendance = [];
        this.attendanceTotals = new CardAttendance();
        const schoolId = this.studentService.studentEnrollment != null ? this.studentService.studentEnrollment.SchoolId : 0;
        this.studentSummaryService.getCardAttendance(this.studentService.selectedStudent.Id, schoolId, this.yearService.student360Year.AYIdentifier, this.yearService.student360Year.Id).subscribe(response => {
            if (response.ok) {
                this.studentAttendance = response.body;
                // Extract total row
                this.attendanceTotals = this.studentAttendance.find(a => a.Class == 'Total Row');
                this.todaysTardyCount = this.attendanceTotals.TodaysTardies;
                this.todaysAbsentCount = this.attendanceTotals.TodaysAbsences;
                this.yearToDateAbsentCount = this.attendanceTotals.TotalAbsences;
                this.yearToDateTardyCount = this.attendanceTotals.TotalTardies;
                this.DaysPresent = this.attendanceTotals.DaysPresent;
                this.TotalDays = this.attendanceTotals.TotalDays;
                this.HoursPresent = this.attendanceTotals.HoursPresent;
                this.TotalHours = this.attendanceTotals.TotalHours;
                // Remove the total row from student attendance
                this.studentAttendance = this.studentAttendance.filter(a => a.Class !== 'Total Row');
                this.dailyAttendanceStatus = this.attendanceTotals.DailyAttendanceStatus;
                // Mock some data
                // this.mockData();
            }
        });
    }

    cardClick() {
        // open the detailed version of the attendance card in a modal window
        if (!this.card.disabled) {
            this.dialog.open(AttendanceCardModalComponent, {
                minWidth: '40vw',
                data: {
                    studentAttendance: this.studentAttendance,
                    totalTardies: this.yearToDateTardyCount,
                    totalAbsences: this.yearToDateAbsentCount,
                    DaysPresent: this.DaysPresent,
                    TotalDays: this.TotalDays,
                    HoursPresent: this.HoursPresent,
                    TotalHours: this.TotalHours
                },
                disableClose: true,
                autoFocus: false
            });
        }
    }

    isDisabled() {
        if (this.card.disabled) {
            return 'disabledColor';
        } else {
            return 'enabledColor';
        }
    }

    mockData() {
        // used to add mock data to the attendance card
        const c1 = new CardAttendance();
        c1.Class = 'English Lit 1';
        c1.Meets = 'P01';
        c1.Marked = 'Tardy';
        this.studentAttendance.push(c1);
        const c2 = new CardAttendance();
        c2.Class = 'Biology 1';
        c2.Meets = 'P05';
        c2.Marked = 'Tardy';
        this.studentAttendance.push(c2);
        const c3 = new CardAttendance();
        c3.Class = 'Intro to Computer Science';
        c3.Meets = 'P06';
        c3.Marked = 'Absent';
        this.studentAttendance.push(c3);
    }

    viewAllClick() {
        this.router.navigateByUrl('/student360/attendance');
    }
}
